/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.w.wilkey@gmail.com>
 */

import { InMemoryCache } from '@apollo/client'
import { generatedIntrospectionSchema } from '@dai/graphql'

const cache = new InMemoryCache({
  possibleTypes: generatedIntrospectionSchema.possibleTypes,
})

export default cache
